import { filtersHelper } from '@/utils';
import { officeTypeModel } from '@/models/api/officeType.model';
import { locationModel } from '@/models/api/location.model';
import { companyModel } from '@/models/api/company.model';

export const officeModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    image: data.image,
    operationHours: data.operation_hours,
    phoneCode: data.phone_code,
    phoneNumber: data.phone_number,
    phoneIso: data.phone_iso,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    officeType: data.office_type ? officeTypeModel(data.office_type) : null,
    location: data.location ? locationModel(data.location) : null,
    companies: (data.companies ?? []).map((item) => companyModel(item)),
});